import { render, staticRenderFns } from "./BarcodeGenerate.vue?vue&type=template&id=0f8bc0b2&scoped=true"
import script from "./BarcodeGenerate.vue?vue&type=script&lang=js"
export * from "./BarcodeGenerate.vue?vue&type=script&lang=js"
import style0 from "./BarcodeGenerate.vue?vue&type=style&index=0&id=0f8bc0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8bc0b2",
  null
  
)

export default component.exports